import { HttpStatusCode } from '@angular/common/http';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ConfirmationService, Message, TreeNode } from 'primeng/api';
import { TreeTable } from 'primeng/treetable';
import { CategoriaPermissao } from 'src/app/admihair/api/dto/categoria-permissao';
import { CategoriaPermissaoAgrupada } from 'src/app/admihair/api/dto/categoria-permissao-agrupada';
import { Empresa } from 'src/app/admihair/api/dto/empresa';
import { Permissao } from 'src/app/admihair/api/dto/permissao';
import { Usuario } from 'src/app/admihair/api/dto/usuario';
import { UsuarioPermissaoEmpresaRequest } from 'src/app/admihair/api/dto/usuario-permissao-empresa-request';
import { CategoriaPermissaoService } from 'src/app/admihair/service/categoria-permissao.service';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { UsuarioPermissaoEmpresaService } from 'src/app/admihair/service/usuario-permissao-empresa.service';
import { UsuarioService } from 'src/app/admihair/service/usuario.service';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';
import { AuthUtil } from 'src/app/admihair/util/auth-util';

@Component({
  selector: 'app-usuario-empresa-inserir',
  templateUrl: './usuario-empresa-inserir.component.html',
  styleUrls: ['./usuario-empresa-inserir.component.scss']
})
export class UsuarioEmpresaInserirComponent implements OnInit {

  @ViewChild('f') form?: NgForm;
  @ViewChild('filter') filter!: ElementRef;
  permissaoInserir: boolean = false;
  loading: boolean = false;
  messages: Message[] = [];
  messagemVisivel: boolean = false;

  usuarioSelecionado?: Usuario;
  empresaSelecionada?: Empresa;
  emailConsulta?: string;
  cpfConsulta?: string;
  tiposBusca: string[] = ['CPF', 'E-mail'];
  buscaSelecionada: string = 'E-mail';
  progressoRequisicao: boolean = false;

  mensagemNovoUsuario: Message[] = [];
  exibirMensagemNovoUsuario: boolean = false;
  novoUsuario: Usuario = {};
  emailValido: boolean = true;
  progressoNovoUsuario: boolean = false;

  exibirDialogPermissao: boolean = false;
  exibirSpinnerDialog: boolean = false;
  exibirDialogNovoUsuario: boolean = false;
  

  colunasTreeTable: any[] = [];
  categoriasTreeTable: TreeNode[] = [];
  categoriasTreeTableSelecionada: TreeNode[] = [];

  colunasTreeTableAdicionadas: any[] = [];
  categoriasTreeTableAdicionadas: TreeNode[] = [];
  categoriasTreeTableAdicionadasSelecionada: TreeNode[] = [];

  constructor(private usuarioService: UsuarioService,
    private categoriaPermissaoService: CategoriaPermissaoService,
    private usuarioPermissaoEmpresaService: UsuarioPermissaoEmpresaService,
    private utilStorageService: UtilStorageService,
    private confirmationService: ConfirmationService,
    private erroService: ErroService) { }


  ngOnInit(): void {
    this.permissaoInserir = AuthUtil.verificarPermissao('PERM_INSERIR_USUARIO_EMPRESA');
    this.empresaSelecionada = this.utilStorageService.getEmpresa();
    this.inicializarColunas();
  }

  inicializarColunas(){
    this.colunasTreeTable = [
      { field: 'descricao', header: 'Permissão' }
    ];
    this.colunasTreeTableAdicionadas = [
      { field: 'descricao', header: 'Permissão' }
    ];
  }


  consultarUsuario() {
    this.categoriasTreeTable = [];
    this.categoriasTreeTableSelecionada = [];
    this.categoriasTreeTableAdicionadas = [];
    const tipo = 'EMPRESA'
    if (this.buscaSelecionada == 'E-mail') {
      this.usuarioService.buscarPorTipoEEmailEEmpresa(tipo, this.emailConsulta, this.empresaSelecionada?.id).subscribe({
        next: (data: Usuario) => {
          this.usuarioSelecionado = data;
          this.messagemVisivel = false;
        },
        error: (err: any) => {
          console.log(err)
          if(err.status === HttpStatusCode.NotFound) {
            this.exibirCadastrarUsuario(err);
          } else {
            this.usuarioSelecionado = undefined;
            this.messages = this.erroService.handleErro(err);
            this.messagemVisivel = true;
            this.rolarTela();
          }
        }
      });
    } else if (this.buscaSelecionada == 'CPF') {
      this.usuarioService.buscarPorTipoECpfEEmpresa(tipo, this.cpfConsulta, this.empresaSelecionada?.id).subscribe({
        next: (data: Usuario) => {
          this.usuarioSelecionado = data;
          this.messagemVisivel = false;
        },
        error: (err: any) => {
          if(err.status === HttpStatusCode.NotFound) {
            this.exibirCadastrarUsuario(err);
          } else {
            this.usuarioSelecionado = undefined;
            this.messages = this.erroService.handleErro(err);
            this.messagemVisivel = true;
            this.rolarTela();
          }
        }
      });
    }
  }

  exibirCadastrarUsuario(err: any){
    this.confirmationService.confirm({
      message: 'Deseja cadastrar o usuário?',
      header: `${this.buscaSelecionada} sem cadastro`,
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.exibirDialogNovoUsuario = true;
        this.novoUsuario.cpf = this.cpfConsulta;
        this.novoUsuario.email = this.emailConsulta;
      },
      reject: () => {
        this.usuarioSelecionado = undefined;
        this.messages = this.erroService.handleErro(err);
        this.messagemVisivel = true;
        this.rolarTela();
      }
    });
  }

  abrirDialogPermissao() {
    this.exibirDialogPermissao = true;
    this.listarCategoriasPermissoes();
  }


  listarCategoriasPermissoes() {
    this.exibirSpinnerDialog = true;
    this.categoriaPermissaoService.listarTodosPorEmpresa().subscribe({
      next: (data: CategoriaPermissaoAgrupada[]) => {
        this.exibirSpinnerDialog = false;
        this.categoriasTreeTable = this.converterParaTreeNode(data)
      },
      error: (err: any) =>{
        console.log(err);
        this.exibirSpinnerDialog = false;
      } 
    });
  }

  converterParaTreeNode(categorias: CategoriaPermissaoAgrupada[]): TreeNode[] {
    return categorias.map(categoria => ({
      data: categoria,
      children: categoria.permissoes ? categoria.permissoes.map(permissao => ({
        data: permissao,
        leaf: true
      })) : []
    }));
  }

  adicionarPermissao() {
    let permissoes: Permissao[] = [];
    for (const item of this.categoriasTreeTableSelecionada) {
      if (!item.children) {
        permissoes.push(item.data);
      }
    }

    let categoriasPermissoes: CategoriaPermissao[] = [];
    for (const perm of permissoes) {
      if (perm.categoriaPermissao) {
        if (!categoriasPermissoes.some(categoria => categoria.id === perm.categoriaPermissao?.id)) {
          categoriasPermissoes.push(perm.categoriaPermissao);
        }
      }
    }

    let categoriasPermissoesAgrupadas: CategoriaPermissaoAgrupada[] = [];

    for (const item of categoriasPermissoes) {
      let permissoesList: Permissao[] = [];
      for (const itemPerm of permissoes) {
        if (itemPerm.categoriaPermissao?.id === item.id) {
          permissoesList.push(itemPerm);
        }
      }
      let categoriaPermissaoAgrupadaItem: CategoriaPermissaoAgrupada = {
        id: item.id,
        descricao: item.descricao,
        permissoes: permissoesList
      }
      categoriasPermissoesAgrupadas.push(categoriaPermissaoAgrupadaItem);
    }

    this.categoriasTreeTableAdicionadas = this.converterParaTreeNode(categoriasPermissoesAgrupadas);
    this.exibirDialogPermissao = false;
  }

  SalvarPermissoes(){
    this.progressoRequisicao = true;

    let permissoes: Permissao[] = [];
    let filhosTree: TreeNode[] = [];
    for(const item of this.categoriasTreeTableAdicionadas){
      if(item.children){
        for(const filho of item.children){
          filhosTree.push(filho);
          permissoes.push(filho.data);
        }
      }
    }

    const listaPermissoesId: number[] = [];
    for(const item of permissoes){
      if(item.id){
        listaPermissoesId.push(item.id);
      }
    }

    const usuarioPerm: UsuarioPermissaoEmpresaRequest = {
      empresaId: this.empresaSelecionada?.id,
      usuarioId: this.usuarioSelecionado?.id,
      permissoesId: listaPermissoesId
    }

    this.usuarioPermissaoEmpresaService.salvarPermissoes(usuarioPerm).subscribe({
      next: () => {
        this.progressoRequisicao = false;
        this.messages = this.erroService.handleSuccess();
        this.messagemVisivel = true;
        this.rolarTela();
      },
      error: (err: any) => {
        this.progressoRequisicao = false;
        this.messages = this.erroService.handleErro(err);
        this.messagemVisivel = true;
        this.rolarTela();
      }
    })

  }

  cadastrarUsuario(){
    if(this.novoUsuario){
      this.progressoNovoUsuario = true;
      this.novoUsuario.apelido = this.formatarApelido(this.novoUsuario.nome);
      this.novoUsuario.senha = '';
      this.novoUsuario.login = this.novoUsuario.email;
      this.novoUsuario.tipo = 'EMPRESA';
      this.novoUsuario.situacaoConfirmacaoConta = 'AGUARDANDO_CONFIRMACAO';
      this.novoUsuario.primeiroAcesso = true;
      this.usuarioService.salvar(this.novoUsuario).subscribe({
        next: (data: Usuario) => {
          this.progressoNovoUsuario = false;
          this.usuarioSelecionado = data;
          this.exibirDialogNovoUsuario = false;
          this.messages =  [{ severity: 'success', summary: 'Sucesso', detail: 'Usuário salvo com sucesso' }];
          this.messagemVisivel = true;
        },
        error: (err: any) => {
          this.progressoNovoUsuario = false;
          this.mensagemNovoUsuario = this.erroService.handleErro(err);
          this.exibirMensagemNovoUsuario = true;
        }
      });
    }
    
  }

  verificarEmailUsuario(temErro?: boolean){
    if(!temErro && this.novoUsuario?.email){
      this.usuarioService.buscarPorEmail(this.novoUsuario.email).subscribe({
        next: (data: Usuario) => {
          console.log(data)
          this.emailValido = false;
        },
        error: (err: any) => {
          if(err.status === HttpStatusCode.NotFound){
            console.log(err)
            this.emailValido = true;
          }
          console.log(err)
        }
      });
    }
    
  }

  formatarApelido(nome?: string): string {
    return nome !== undefined ? nome.split(' ')[0] : '';
  }

  limparUsuario() {
    this.usuarioSelecionado = undefined;
    this.emailConsulta = '';
    this.cpfConsulta = '';
    this.messagemVisivel = false;
  }

  buscar(table: TreeTable, event: Event) {
    table.filterGlobal((event.target as HTMLInputElement).value, 'contains');
  }

   limpar(table: TreeTable) {
    table.filterGlobal('', 'contains');
    this.filter.nativeElement.value = '';
  }

  rolarTela() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }

  verificarPermissao(nome: string): boolean{
    return AuthUtil.verificarPermissao(nome);
  }

}
